<template>
  <v-layout v-if="feature" justify-center>
    <v-flex shrink>
      <v-btn @click="newSearch" color="blue" dark :loading="loadingItems" round>
        <v-icon>search</v-icon>
        <span>Buscar items</span>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState("featureRules", ["feature", "loadingItems"])
  },
  methods: {
    ...mapActions("featureRules", ["setItemsPagination"]),
    newSearch() {
      this.setItemsPagination({ pagination: { page: 1 } });
    }
  }
};
</script>
